var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M13.577.702 12.865 0 4 8.994l8.867 8.885.708-.707L5.408 8.99z"}));
}

ArrowLeft.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
